import { Card, CardContent, CardTitle } from "@/shared/ui/card";
import { Building2, ChevronRight } from "lucide-react";
import { Organization } from "@/shared/types/userTypes";

interface OrganizationCardProps {
  organization: Organization;
  onManageOrganization?: () => void;
}

const OrganizationCard = ({
  organization,
  onManageOrganization
}: OrganizationCardProps) => {
  return (
    <Card
      className="hover:shadow-lg transition-shadow duration-200 border cursor-pointer"
      onClick={onManageOrganization}>
      <CardContent className="flex flex-col gap-4 p-4">
        {/* Header Section */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 rounded-lg flex items-center justify-center border">
              <Building2 className="h-6 w-6" />
            </div>
            <div className="flex flex-col">
              <CardTitle className="text-lg">{organization.name}</CardTitle>
            </div>
          </div>
          <ChevronRight className="h-8 w-8 ml-auto" />
        </div>
      </CardContent>
    </Card>
  );
};

export default OrganizationCard; 